const SALESFORCE_SOURCE_SYSTEM = 'Salesforce';

const toLocationIdSet = (ids = []) =>
    new Set(ids.filter((id) => id != null).map((id) => String(id)));

/**
 * Detects Salesforce-migrated multi-location timesheets where clinician time was
 * entered on multiple locations but the PTS only has time on a single location.
 * Note: locationPTSIds are processed timesheet record IDs, not work location IDs.
 */
export const hasProcessedTimesheetLocationMismatch = (details) => {
    if (details?.sourceSystem !== SALESFORCE_SOURCE_SYSTEM) {
        return false;
    }

    const clinicianLocationIds = toLocationIdSet(
        details?.timeEntries?.entriesByLocation?.map(({ locationId }) => locationId)
    );
    const processedLocationIds = toLocationIdSet(
        details?.processedTimesheetEntries?.map(({ locationId }) => locationId)
    );

    return clinicianLocationIds.size > 1 && processedLocationIds.size === 1;
};

export const LOCATION_MISMATCH_WARNING_MESSAGE =
    'The locations on this processed timesheet do not match the clinician timesheet. Please contact Tech to correct the processed timesheet locations before continuing corrections.';
